import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { ApiDataClient } from '../../Api/ApiDataClient';

interface CreateRouteDialogProps {
    open: boolean;
    projectId: number;
    onClose: () => void;
    onRefresh?: () => void;
}
export default function CreateRouteDialog(props: CreateRouteDialogProps) {
    const { open, onClose, onRefresh, projectId } = props;

    const [name, setName] = React.useState<string>();
    const [state, setState] = React.useState<number>();
    const [buttonDisabled, setButtonDisabled] = React.useState<boolean>(false);

    useEffect(() => {
    }, []);

    return (
        <Dialog
            open={open}
            onClose={() => { onClose() }}
            aria-labelledby="create-dialog-title"
            aria-describedby="create-dialog-description"
        >
            <DialogTitle id="create-route-dialog-title" sx={{ background: '#F5F5F5'}}>
                <div  >
                    <div style={{ marginRight: '20px', minWidth: '200px' }}>Založení trasy</div>
                    <IconButton sx={{ width: '30px', height: '30px', right: '20px', top: '18px', float: 'right', position: 'absolute' }}
                        onClick={() => { setName(undefined); onClose(); }}><Close /></IconButton>
                </div>
            </DialogTitle>
            <DialogContent>
                    <div>
                        <TextField sx={{ margin: '12px', width: '526px' }} label={'Název trasy'}
                            size='small'
                            name='userName'
                            variant='outlined'
                            value={name}
                            error={!name}
                            onChange={(e) => { setName(e.target.value) }} />
                        <div style={{ margin: '12px', width: '526px' }}>
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="demo-simple-select-standard-label">Stav</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={state}
                                    onChange={(v) => { if (v.target.value) setState(parseInt(v.target.value.toString())) }  }
                                    label="Stav">
                                    <MenuItem value="0">Nový</MenuItem>
                                    <MenuItem value="1">Aktivní</MenuItem>
                                    <MenuItem value="2">K revizi</MenuItem>
                                    <MenuItem value="3">Dokončeno</MenuItem>
                                    <MenuItem value="4">Uzavřeno</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                            <Button variant='contained' sx={{ margin: 'auto' }} disabled={name === undefined || buttonDisabled} onClick={() => {
                                console.log('hej: ', name, state, projectId);
                                if (name && state !== undefined) {
                                    console.log('hej2');
                                    setButtonDisabled(true);
                                    new ApiDataClient().CreateRoute(name, state, projectId).then((v) => {
                                        setButtonDisabled(false);

                                        if (onRefresh)
                                            onRefresh();

                                        onClose();
                                    });
                                }
                            }}>Přidat</Button>
                        </div>
                    </div>
            </DialogContent>
        </Dialog>
    )
}
